import { supabase } from "@/integrations/supabase/client";

// Busca a nota mais recente (última mensagem do assistente com score) de cada persona.
export async function fetchLatestScores(personaIds: string[]): Promise<Record<string, number>> {
  if (!personaIds.length) return {};
  const { data, error } = await supabase
    .from("historicos")
    .select("persona_id, score, created_at")
    .in("persona_id", personaIds)
    .eq("role", "assistant")
    .not("score", "is", null)
    .order("created_at", { ascending: false });

  if (error || !data) return {};

  const map: Record<string, number> = {};
  for (const row of data as any[]) {
    if (row.persona_id && map[row.persona_id] === undefined && row.score !== null) {
      map[row.persona_id] = Number(row.score);
    }
  }
  return map;
}

export function scoreColorClasses(score: number): string {
  if (score >= 80) return "bg-green-500/15 text-green-600 border-green-500/30";
  if (score >= 60) return "bg-lime-500/15 text-lime-600 border-lime-500/30";
  if (score >= 40) return "bg-yellow-500/15 text-yellow-600 border-yellow-500/30";
  if (score >= 20) return "bg-orange-500/15 text-orange-600 border-orange-500/30";
  return "bg-red-500/15 text-red-600 border-red-500/30";
}
